import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  CircularProgress,
  Paper,
  Typography,
} from '@mui/material';
import useAPICall from '../../hooks/useAPICall';
import { API_CONFIG } from '../../config/api.config';
import GlobalMaterialTable from '../../components/common/GlobalMaterialTable';

const HCPInbox = () => {
  const navigate = useNavigate();
  const { loading, error, data, execute } = useAPICall();
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });

  useEffect(() => {
    const load = async () => {
      try {
        await execute(API_CONFIG.inbox.getHCPRequests, null, {
          errorMessage: 'Unable to load HCP batches.',
          retries: 1,
        });
      } catch {
      }
    };
    load();
  }, [execute]);

  const rows = useMemo(() => (Array.isArray(data) ? data : data?.data || data?.results || []), [data]);

  const getPendingCount = (requests = []) => {
    return requests.filter((req) => req.requestStatus !== 'CLOSED').length;
  };

  const onOpenBatch = (row) => {
    if (!row?.batchId) return;
    navigate(`/hcp-new-request?batchId=${row.batchId}`);
  };

  return (
    <Box>
      <Box>
        <GlobalMaterialTable
          state={{ isLoading: loading }}
            columns={[
              { header: 'Batch ID', id: 'batchId', accessorFn: (row) => row.batchId || '-', size: 120 },
              { header: 'Created Time', id: 'createdTime', accessorFn: (row) => row.batchCreatedTime || '-', size: 160 },
              { header: 'Last Updated Time', id: 'updatedTime', accessorFn: (row) => row.batchLastUpdatedTime || '-', size: 160 },
              { header: 'Status', id: 'status', accessorFn: (row) => row.batchStatus || '-', size: 120 },
              {
                header: 'Request Count',
                id: 'requestCount',
                accessorFn: (row) => (Array.isArray(row.requests) ? row.requests.length : 0),
                size: 130,
              },
              {
                header: 'Pending Requests',
                id: 'pendingCount',
                accessorFn: (row) => (Array.isArray(row.requests) ? getPendingCount(row.requests) : '-'),
                size: 140,
              },
              { header: 'Last Updated By', id: 'updatedBy', accessorFn: (row) => row.batchLastUpdatedBy || '-', size: 150 },
            ]}
            data={rows}
            emptyMessage="No Open Batches"
            initialState={{ density: 'compact' }}
            enablePagination
            enableBottomToolbar
            manualPagination={false}
            page={pagination.pageIndex + 1}
            pageSize={pagination.pageSize}
            onPageChange={(p) => setPagination(prev => ({ ...prev, pageIndex: p - 1 }))}
            onPageSizeChange={(ps) => setPagination(prev => ({ ...prev, pageSize: ps }))}
            tableTitle="System Inbox"
            tableCount={rows.length}

            muiTableBodyRowProps={({ row }) => ({
              onDoubleClick: () => onOpenBatch(row.original),
              sx: { cursor: 'pointer' },
            })}
        />
      </Box>
    </Box>
  );
};

export default HCPInbox;
